<template>
    <div>
      <nx-dialog
        :visible.sync="show"
        title="删除机械备案信息"
        width="600px"
        :before-close="beforeClose"
        @onConfirm="onConfirm"
      >
        <nx-form
          ref="submitForm"
          :source="submitForm"
          :config="submitConfig"
        ></nx-form>
      </nx-dialog>
    </div>
  </template>
  <script>
  import { deleteMachineRecord } from '@/api/notRoadFour/machineRecord';
  
  export default {
    name: '',
    components: {},
    props: {
      visible: {
        type: Boolean
      },
      id: {
        type: [String, Number],
        default: () => ''
      },
      type: {
        type: String,
        default: () => ''
      }
    },
    data() {
      return {
        show: false,
        submitForm: {
          name: '', // 联系人姓名
          phone: '', // 联系人电话
          email: '', //联系人电子邮箱
          removeAuthorizeImg: '', // 删除授权文件
        }
      };
    },
    computed: {
      submitConfig() {
        return [
          {
            key: 'name',
            component: 'el-input',
            span: 24,
            label: '联系人姓名:',
            props: {
              placeholder: '请输入联系人姓名'
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (this.$validate.hasSpace(value)) {
                      return callback(new Error('不能输入空格'));
                    }
                    callback();
                  }, trigger: 'blur'
                }
              ]
            }
          },
          {
            key: 'phone',
            component: 'el-input',
            span: 24,
            label: '联系人电话:',
            props: {
              placeholder: '请输入联系人电话',
              maxLength: 11
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入联系人电话', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (this.$validate.hasSpace(value)) {
                      return callback(new Error('不能输入空格'));
                    }
                    if (this.$validate.isPhone(value)) {
                      return callback();
                    }
                    return callback(new Error('请输入正确的手机号码'));
                  }, trigger: 'blur'
                }
              ]
            }
          },
          {
            key: 'email',
            component: 'el-input',
            span: 24,
            label: '电子邮箱:',
            props: {
              placeholder: '请输入电子邮箱',
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (this.$validate.hasSpace(value)) {
                      return callback(new Error('不能输入空格'));
                    }
                    callback();
                  }, trigger: 'blur'
                }
              ]
            }
          },
          {
            key: 'removeAuthorizeImg',
            component: 'nx-upload',
            span: 24,
            label: '删除授权文件:',
            props: {
              placeholder: '请选择jpg文件格式上传，大小不超过2M',
              size: 2,
              obsType: 'transfer',
              reg: /.(jpg)$/
            },
            itemProps: {
              rules: [
                { required: true, message: '请上传删除授权文件', trigger: 'blur' }
              ]
            },
            tips: '请选择jpg文件格式上传，大小不超过2M'
          }
        ];
      }
    },
    watch: {
      visible: {
        handler(visible) {
          this.show = visible;
        }
      },
      show: {
        handler(show) {
          if (show && this.id) {
            // this.getDetailById(this.id);
          }
          this.$emit('update:visible', show);
        }
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      // 提交表单
      async onConfirm() {

        const valid = await this.$refs.submitForm.validate();
        console.log('打印提交表单值:--->' + valid);
        if (!valid) return;
        const params = {
          ...this.submitForm,
          vehicleFrameNo: this.id
        };
        await deleteMachineRecord(params);
        this.$message.success('操作成功');
        this.show = false;
        this.$emit('onConfirm');
      },
      // 关闭前回调
      beforeClose(done) {
        this.$refs.submitForm.resetFields();
        delete this.submitForm.id;
        done();
      }
    }
  };
  </script>
  <style scoped lang="scss">
  </style>
  